var map = {
	"./ArrowDown.svg": 1072,
	"./ArrowUp.svg": 1073,
	"./Calendar.svg": 155,
	"./ChevronDown.svg": 475,
	"./ChevronLeft.svg": 135,
	"./Info.svg": 508,
	"./Lock.svg": 509,
	"./Money.svg": 1074,
	"./Profile.svg": 374,
	"./TopUp.svg": 1075
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1071;